import { gql } from "@apollo/client";

export const CREATE_PRODUCT = gql`
  mutation CreateProduct($product: CreateProductInput) {
    createProduct(product: $product) {
      _id
      name
      make
      model
      category
      external_description
      repairShopr_id
      retail_price
      created_at
      updated_at
      tags
    }
  }
`;

export const CREATE_PRODUCTS = gql`
  mutation CreateProducts($products: [CreateProductInput]) {
    createProducts(products: $products) {
      _id
      name
      make
      model
      category
      external_description
      repairShopr_id
      retail_price
      created_at
      updated_at
      tags
    }
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($product: UpdateProductInput) {
    updateProduct(product: $product) {
      _id
      name
      make
      model
      category
      external_description
      repairShopr_id
      retail_price
      created_at
      updated_at
      tags
    }
  }
`;

export const DELETE_PRODUCT = gql`
  mutation DeleteProduct($product: DeleteProductInput) {
    deleteProduct(product: $product) {
      _id
      name
      make
      model
      category
      external_description
      repairShopr_id
      retail_price
      created_at
      updated_at
      tags
    }
  }
`;

export const DELETE_MANY_PRODUCTS = gql`
  mutation DeleteManyProducts($products: [DeleteProductInput]) {
    deleteManyProducts(products: $products) {
      _id
      name
      make
      model
      category
      external_description
      repairShopr_id
      retail_price
      created_at
      updated_at
      tags
    }
  }
`;
